<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <h2 class="mb-4">Common Mistakes in Issue Statements</h2>

      <p class="mb-2">What are common mistakes in crafting issue statements?</p>

      <p v-for="option in optionsShuffled" :key="'pt-1-' + option.value" class="mb-0 mt-0">
        <v-checkbox
          v-model="inputs.studentAnswers"
          :value="option.value"
          :label="option.text"
          class="mb-n4 mt-0 pl-6"
        >
        </v-checkbox>
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';

export default {
  name: 'MarketingScaffoldedTasks_Phase1Task3',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswers: [],
      },
      options: [
        {text: 'Not identifying a clear and specific marketing concept', value: 'noMarketingTool'},
        {text: 'Focusing on operational, financial, or HR issues', value: 'wrongIssues'},
        {text: 'Being overly broad or vague', value: 'tooBroad'},
        {text: 'Including a recommendation', value: 'includingRecommendation'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
